<template>
    <div class="w3-container flow-card blue-top w3-large">

        <div v-if="showSuccess">
            <div class="w3-col w3-margin w3-center">
                <h3>
                    <p class="flow-blue-color">
                        {{ $t("afterAccountUpdateSuccess") }}
                    </p>
                </h3>

                <div class="w3-col w3-center w3-margin w3-padding-large">
                    <router-link :to="{name: 'logout'}" class="flow-btn w3-btn w3-round w3-border w3-round-medium flow-blue-color">
                        <i class="fa fa-sign-out-alt w3-text-deep-orange"></i>
                        <span><b class="flow-margin-left">{{ $t("logout") }}</b></span>
                    </router-link>
                </div>
            </div>
        </div>

        <div v-else>
            <div v-if="showForm">
                <account-form :onSave="onSave"></account-form>
            </div>

            <div v-else>
                <h2 class="w3-center flow-blue-color">
                    <b>{{ $t("hello") }}</b>, {{ overview.displayName }}!
                </h2>

                <div class="w3-col w3-margin w3-center">
                    <h4>
                        <p v-if="showIncomplete" class="w3-text-deep-orange">
                            <i class="fa fa-exclamation-circle"></i>
                            {{ $t("warnIncompleteAccountUpdate") }}
                        </p>
                        <p v-else class="flow-blue-color">
                            {{ $t("beforeAccountUpdateMessage") }}
                        </p>
                    </h4>
                </div>

                <div class="w3-col w3-center w3-margin w3-padding-large">
                    <button class="flow-btn w3-btn w3-round w3-border w3-round-medium flow-blue-color"
                            @click.prevent="showForm = true">
                        <i class="fa fa-arrow-right flow-green-active-color"></i>
                        <span>
                            <b class="flow-margin-left">
                                {{ $t("start") }}
                            </b>
                        </span>
                    </button>

                    <router-link :to="{name: 'logout'}"
                                 class="w3-right flow-btn w3-btn w3-round w3-border w3-round-medium flow-blue-color">
                        <i class="fa fa-sign-out-alt w3-text-deep-orange"></i>
                        <span><b class="flow-margin-left">
                            {{ $t("logout") }}
                        </b></span>
                    </router-link>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import AccountForm from "./AccountForm";

    const frc = Vue.prototype.$frc;

    export default {
        name: "UpdateSelfAccount",
        components: {AccountForm},
        props: ["overview"],
        data() {
            return {
                showForm: false,
                showSuccess: false,
                showIncomplete: false
            }
        },
        methods: {
            onSave() {
                const app = this;
                app.showForm = false;
                app.showSuccess = false;
                app.showIncomplete = false;

                frc.isAccountComplete().then(function (res) {
                    if (res.data === true) {
                        app.showSuccess = true;
                    } else {
                        app.showIncomplete = true;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>